import { enUS } from "date-fns/locale";

export const EN_US_LOCALE_STRING = "en-US";

// arbitrary number to use for extracting decimal separator
// in a given locale
const NUM_IN_DEFAULT_LOCALE = 1.1;

export function getLocalization(settings) {
  const { dateFormat, homeCurrency } = settings;

  // get decimal number decimal point character
  const decimalSeparator = Intl.NumberFormat(EN_US_LOCALE_STRING)
    .formatToParts(NUM_IN_DEFAULT_LOCALE)
    .find(({ type }) => type === "decimal").value;

  // get minimum decimal places for currency
  const currencyMinimumFractionDigits = new Intl.NumberFormat(
    EN_US_LOCALE_STRING,
    {
      style: "currency",
      currency: homeCurrency.code,
    }
  ).resolvedOptions().minimumFractionDigits;

  return {
    decimalSeparator,
    currencyMinimumFractionDigits,
    validNumber: new RegExp("^-?\\d*\\" + decimalSeparator + "?\\d*$"),
    dateFormat: dateFormat || enUS.formatLong.date({ width: "short" }),
    homeCurrency: homeCurrency?.code,
  };
}
